module.exports = __webpack_public_path__ + "static/media/6. BesanPistachio Khatai 300g.27b29162.jpg";